'use strict';
import axios from 'axios';
import getHeader from '../config/header';

const API_URL = process.env.VUE_APP_API_URL || "http://localhost:3001/api";

const Countries = {

    async getAll() {
		try {
            let response = await axios.get(API_URL + '/countries');
            
			return response.data;

		} catch(error) {
            return false;
		}
	}
    
}

export default Countries;